import { Theme } from "@mui/material/styles";

export default function Autocomplete(theme: Theme) {
    return {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root .MuiAutocomplete-input ": {
                        padding: theme.spacing(0.125, 0, 0.125, 0.625),
                    },
                },
                popper: {
                    paddingTop: theme.spacing(1),
                    // "& .MuiAutocomplete-noOptions": {
                    //     display: "none",
                    // },
                },
                paper: {
                    boxShadow: theme.customShadows.dropdown,
                },
                listbox: {
                    // padding: theme.spacing(0, 1),
                    "& .MuiAutocomplete-option": {
                        padding: theme.spacing(1, 2),
                        // margin: theme.spacing(1, 0),
                        // borderRadius: theme.shape.borderRadius,
                    },
                },
            },
        },
    };
}
